// removed by extract-text-webpack-plugin
module.exports = {"btnDraw":"src-components----Link-module---btnDraw---1a07N","btnDrawFilled":"src-components----Link-module---btnDrawFilled---1LtCR","btnDrawSimple":"src-components----Link-module---btnDrawSimple---1nUzw","btnDrawActive":"src-components----Link-module---btnDrawActive---3Aafx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Link.module.css
// module id = 728
// module chunks = 168707334958949